import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-consultazione-bilanci',
  templateUrl: './consultazione-bilanci.component.html',
  styleUrls: ['./consultazione-bilanci.component.css']
})
export class ConsultazioneBilanciComponent implements OnInit {
  lstElenco: any;

  lstPercorso: any
  id: string = '901';

  public sMessaggio: string = '';
  //sMessaggio: string = 'Attendere il caricamento del PDF.....';

  constructor(private router: Router,
    private srvUtilita: UtilitaService) { }

  ngOnInit(): void {
    this.getLista();
  }

  btnIndietro() {
    this.router.navigate(['/dashboard/']);
  }

  getLista() {
    this.sMessaggio = "Attendere il caricamento del PDF.....";
    this.srvUtilita.getLista('Tabelle/GetDocumentoPDFUtenteLista').subscribe((res: any) => {
      this.lstElenco = res;
      //   console.log('res', res)

      this.sMessaggio = '';
    })
  }

  btnVisibile(row: any) {

    this.srvUtilita.getLista('Tabelle/getPercorso?id=' + this.id).subscribe((res: any) => {
      this.lstPercorso = res;
     // console.log('percorso', this.lstPercorso)

     // console.log(this.lstPercorso + row.FileName)
      window.open(this.lstPercorso + row.FileName);
  })
}

}
